/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-26 15:44:57
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-26 15:58:59
 * @FilePath: /unifyxp-v2-store-portal/src/components/LoadLanding/index.tsx
 */
import React from 'react';
//import Uploader from './Uploader';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { ColorLinedButton } from 'src/components/Antd/Button/Button';
import css from './css.module.less';

const Component = (props) => {
  const { containerClassName } = props;
  const [dragIn, setDragIn] = React.useState(false);

  return (
    <div
      className={`${css.componentContainer} ${dragIn ? css.dragIn : ''} ${
        containerClassName || ''
      }`}
      onDragLeave={() => {
        setDragIn(false);
      }}
      onDrop={() => {
        setDragIn(false);
      }}
      onDragOver={() => {
        setDragIn(true);
      }}>
      {/* <Spin spinning={loading} tip={`${loadingPercentage}%`}> */}

      <div className={css.tipContainer}>
        <span className={css.tip}>
          {getI18nFromGeneral('general.antd.Uploader.tip')}
        </span>
        <span className={css.tipNormal}>
          {getI18nFromGeneral('general.antd.Uploader.or')}
        </span>
        <ColorLinedButton className={css.btn}>
          {getI18nFromGeneral('general.antd.Uploader.upload_files')}
        </ColorLinedButton>
      </div>

      {/* </Spin> */}
    </div>
  );
};
export default Component;
